module.exports = __webpack_public_path__ + "static/img/runbo4.9df786c.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgs/runbo4.png
// module id = WYWQ
// module chunks = 4